import type {
  CalculationType,
  RmCalculationType,
  RrpCalculationType,
} from '@/api';
import SummaryRow from '@/pages/price-planning/copy-price-page/components/summary-row';
import { TextLink } from '@lego/connect-components-react';
import { useState } from 'react';
import { useGetCalculationSettingsByPriceUnitIdAndYear } from '../calculation-settings/calculation-settings-queries';
import {
  CALCULATION_TYPE_LABELS,
  RM_CALCULATION_TYPE_LABELS,
  RRP_CALCULATION_TYPE_LABELS,
} from '../calculation-settings/tabs/settings/types';

type ConditionsSectionProps = {
  priceUnitId: number;
  year: number;
};

const ConditionsSection = ({ priceUnitId, year }: ConditionsSectionProps) => {
  const { data } = useGetCalculationSettingsByPriceUnitIdAndYear(
    priceUnitId,
    year,
  );
  const [conditionsExpanded, setConditionsExpanded] = useState<boolean>(true);

  return (
    <div>
      <TextLink
        href="#"
        onClick={() => setConditionsExpanded(!conditionsExpanded)}
        variant="emphasis"
        iconName={conditionsExpanded ? 'chevron-up' : 'chevron-down'}
        iconPosition="start"
        size="small"
      >
        {conditionsExpanded ? 'Hide conditions' : 'Show conditions'}
      </TextLink>
      {conditionsExpanded && (
        <>
          <SummaryRow
            label="Novelty Calc Type"
            value={
              CALCULATION_TYPE_LABELS[
                data?.calculationType as CalculationType
              ] ?? '-'
            }
            size="small"
          />
          <SummaryRow
            label="Retail Margin %"
            value={
              RM_CALCULATION_TYPE_LABELS[
                data?.rmCalculationType as RmCalculationType
              ] ?? '-'
            }
            size="small"
          />
          <SummaryRow
            label="Recommended Retail Price"
            value={
              RRP_CALCULATION_TYPE_LABELS[
                data?.rrpCalculationType as RrpCalculationType
              ] ?? '-'
            }
            size="small"
          />
          <SummaryRow
            label="Target List Price Index"
            value={data?.targetLpIndex?.toString() ?? '-'}
            size="small"
          />
          <SummaryRow
            label="Calculation Basis"
            value={data?.calculationBasisPriceUnit?.name ?? '-'}
            size="small"
          />
          <SummaryRow
            label="Auto Calc enabled"
            value={data?.enableAutoCalc ? 'Yes' : 'No'}
            size="small"
          />
        </>
      )}
    </div>
  );
};
export default ConditionsSection;
